export default () => ({
  list: [],
  items: {}
})
